import React from "react";

import {createTheme, ThemeProvider} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import {TooltipDetailsItemPopup} from "./TooltipDetailsItemPopup/TooltipDetailsItemPopup";
import {ReactComponent as ApprovePromotionForSystem} from "../../../assets/promos&items/approved_item_in_promo_system.svg";
import {PromoItemsDto} from "../../../dtos";
import {ReactComponent as ApprovePromotion} from "../../../assets/promos&items/approved_item_in_promo.svg";
import {ReactComponent as NotApprovePromotion} from "../../../assets/promos&items/not_approved_item_in_promo.svg";
import styles from './QualificationForItemComponent.module.scss'

const theme = createTheme({
    components: {
        // Name of the component
        MuiTooltip: {
            styleOverrides: {
                // Name of the slot
                tooltip: {
                    // Some CSS
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    maxWidth: '600px',
                    width: '600px',
                    maxHeight: '420px',
                    border: '1px solid #4D4D4D',
                    borderRadius: '5px',
                },
            },
        },
    },
});

interface Props {
    item: PromoItemsDto;
    editItem: (e: React.MouseEvent<HTMLElement>) => void;
    itemQualification: number | undefined
}


export const QualificationForItemComponent: React.FC<Props> = (
    {
        item,
        editItem,
        itemQualification
    }
) => {
    let QualificationIcon;
    switch (itemQualification){
        case 1:
            QualificationIcon = ApprovePromotionForSystem;
            break
        case 2:
            QualificationIcon = ApprovePromotion;
            break
        default:
            QualificationIcon = NotApprovePromotion;
            break;
    }

    return (
        <div className={styles.qualification_lvl_item_wrapper}>
            <ThemeProvider theme={theme}>
                <Tooltip
                    enterDelay={500}
                    enterNextDelay={500}
                    title={<TooltipDetailsItemPopup
                        item={item}
                        editItem={editItem}
                    />}
                    placement={"right-start"}
                >
                    <QualificationIcon />
                </Tooltip>
            </ThemeProvider>
        </div>
    )
}